<template>
<div class="table-responsive">
	<table class="table table-striped table-hover notices" :class="{'loading': loading}">
		<thead>
			<tr>
				<th class="nowrap" scope="col" v-for="(key,index) in keys" :key="index" @click="sort_click(key)">
					{{ $t('keys.' + key) }}
					<i v-if="column===key && direction=='ASC'" class="far fa-sort-up"></i>
					<i v-if="column===key && direction=='DESC'" class="far fa-sort-down"></i>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(notice,index) in notices" :key="index" @click="details(notice, $event)">
				<td v-for="(key,yndex) in keys" :key="yndex" :class="{'address' : key==='address'}">
					<span v-if="dates.indexOf(key) != -1 && notice[key]">{{ notice[key] | moment('YYYY-MM-DD') }}</span>
					<span v-else-if="key==='notice_id'"><router-link :to="{name: 'Detail', params: {id: notice.notice_type + '-' + notice.notice_id }}">{{ notice[key] }}</router-link></span>
					<span v-else>{{ notice[key] }}</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
</template>

<script>

	export default {
		data() {
			return {
				direction: 'ASC',
				column: '',
			}
		},
		created() {
			if (this.default_column) {
				this.column = this.default_column;
			}
			if (this.default_direction) {
				this.direction = this.default_direction;
			}
		},

		props: ['notices','keys', 'dates','loading', 'default_column', 'default_direction'],

		methods: {

			sort_click(column) {
				this.column = column;
				this.direction = (this.direction === 'ASC') ? 'DESC' : 'ASC';
				this.$emit('sort_click',{column: column, direction: this.direction });

			},

			details(notice, event) {
				if (!event.target || !event.target.nodeName || (event.target.nodeName !== "A")) {
					this.$router.push({name: 'Detail', params: { id: notice.notice_type + '-' + notice.notice_id }});
				}
			}
		}
	}

</script>

<style >
tr {
	cursor: pointer;
}
/* .nowrap {
	white-space: nowrap;
} */
table.notices > tbody > tr > td:not(.address) > span {
	white-space: nowrap;
}

table.loading {
	opacity: 0.5;
}
</style>
